import { http } from '@/core/helpers/axiosHelper';
import { CertificateType } from './certificate-type.interface';

export class CertificateTypeService {
   async getCertificateTypes() {
      const response = await http.get<Array<CertificateType>>(`/certificate-types`);
      return response.data;
   }

   async getCertificateType() {
      throw Error('Method not implemented');
   }

   async postCertificateType() {
      throw Error('Method not implemented');
   }

   async putCertificateType() {
      throw Error('Method not implemented');
   }

   async deleteCertificateType() {
      throw Error('Method not implemented');
   }
}
